import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { StartupGate } from "@/components/StartupGate";
import { PUBLIC_CONFIG } from "@/lib/publicSite";

// Do not evaluate application imports before configuration has been checked.
// Keep this synchronous so the recovery screen needs no additional app chunks.
const App = PUBLIC_CONFIG.valid ? require("@/App").default : null;

// Keep raw-HTML previews for non-JS crawlers, then hand ownership to Helmet.
// Removing only our marked fallbacks prevents duplicate static/client tags.
document.head.querySelectorAll("[data-seo-fallback]").forEach(node => node.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StartupGate config={PUBLIC_CONFIG}>{App ? <App /> : null}</StartupGate>
  </React.StrictMode>,
);
